import { DestroyRef, inject } from '@angular/core';
import { Subject } from 'rxjs';
import {
  LoadingController,
  ModalController,
  NavController
} from '@ionic/angular';
import { LoadingService, NotificationService } from '@incust-mobile/core';

export abstract class BaseAbstractModal {
  protected readonly destroy$ = new Subject<void>();
  protected readonly destroyRef = inject(DestroyRef);
  protected modalCtrl = inject(ModalController);
  protected loadingService = inject(LoadingService);
  protected notificationService = inject(NotificationService);
  protected navCtrl = inject(NavController);

  protected constructor() {}

  async dismiss() {
    await this.modalCtrl.dismiss();
  }
}
